export const redirectToHome = () => {
    window.location.href = window.location.protocol+"//"+window.location.host;
};
export const isUndefined = str => {
    return !(str !== undefined && str.length > 0);
}

export const loadScript = (src, compId) => {
    const script = document.createElement('script');
    script.src = src; // URL for the third-party library being loaded.
    script.id = compId;
    document.body.appendChild(script);
};

export const ENVIRONMENT = {
    LOCAL: 'localhost',
    DEV: 'wwwdev.vodacombusiness.co.za',
    QA: 'wwwqa.vodacombusiness.co.za',
    STAGING: 'wwwstg.vodacombusiness.co.za' // also know as 'staging'
};

export const URLS = {
    LOCAL: 'http://tags.tiqcdn.com/utag/vodafone/za-microservice/dev/utag.sync.js',
    DEV: '/cloud/cached/utag/vodafone/za-microservice/dev/utag.sync.js',
    QA: '/cloud/cached/utag/vodafone/za-microservice/qa/utag.sync.js',
    STAGING: '/cloud/cached/utag/vodafone/za-microservice/prod/utag.sync.js',
    PROD: '/cloud/cached/utag/vodafone/za-microservice/prod/utag.sync.js'
};

export const getUtagUrl = () => {
    var host = window.location.hostname;
    var url = "";
    switch (host) {
        case ENVIRONMENT.LOCAL:
            url = URLS.LOCAL;
            break;
        case ENVIRONMENT.DEV:
            url = URLS.DEV;
            break;
        case ENVIRONMENT.QA:
            url = URLS.QA;
            break;
        case ENVIRONMENT.STAGING:
            url = URLS.STAGING;
            break;
        default:
            url = URLS.PROD;
    }
    return url;
};

export const ERROR_PAGE_MSG = "We've encountered a technical issue. Please try again later.";
export const ATTEMPT_MAX_TRIED_ERROR_MSG = "You have already tried maximum number of tries.";
export const SET_PRODUCT_NAME = "SET_PRODUCT_NAME";

export const productNameList=[
    'Thermal Scanning',
    'People and Spaces',
    'Stock Visibility',
    'Connected Assets and Smart Tracking',
    'Econz Wireless',
    'Aita health',
    'Citizen Engagement',
    'Secure Device Manager',
    'Push To Talk',
    'Remote office',
    'Huawei cloud',
    'Digital buildings',
    'Smart integration',
    'Smart spaces',
    'Smart environment',
    'Smart utilities'
]
